    import { subscribeNewsletter } from "../api/send/subcribe_newsletter";
    
    // Odběr newsletteru
    export const handleSubscribeUsSubmit = async (formData) => {
        console.log(formData);
        try {
            await subscribeNewsletter(formData);
            return { success: true, message: 'Odběr newsletteru byl úspěšně odeslán!' };
        } catch (error) {
            console.error('Chyba při odběru newsletteru:', error);
            return { success: false, message: 'Nepodařilo se odběru newsletteru. Zkuste to prosím znovu.', error: error };
        }
    }